export enum AppConfigurationKey {
  StorageAccountName = 'StorageAccountName',
  StorageDispatches = 'Dispatches:Storage',
  Host = 'Host:ApiManagement',
  ApiUrlSuffixRBAC = 'PrefixEnviromentRBAC',
  ApiUrlSuffixPioneer = 'PrefixEnviromentPioneer',
  ApiUrlSuffixBalance = 'PrefixEnviromentBalance',
  ApiUrlSuffixBatch = 'PrefixEnviromentBatch',
  ApiUrlSuffixBuques = 'PrefixEnviromentBuques',
  ApiUrlSuffixCapacidades = 'PrefixEnviromentCapacidades',
  ApiUrlSuffixComunicaciones = 'PrefixEnviromentComunicaciones',
  ApiUrlSuffixConfigOperacionesBalance = 'PrefixEnviromentConfigOperacionesBalance',
  ApiUrlSuffixConfigServiciosCapacidad = 'PrefixEnviromentConfigServiciosCapacidad',
  ApiUrlSuffixContratos = 'PrefixEnviromentContratos',
  ApiUrlSuffixDispatches = 'PrefixEnviromentDispatches',
  ApiUrlSuffixDocumentos = 'PrefixEnviromentDocumentos',
  ApiUrlSuffixElementosLogisticos = 'PrefixEnviromentElementosLogisticos',
  ApiUrlSuffixFacturas = 'PrefixEnviromentFacturas',
  ApiUrlSuffixOperaciones = 'PrefixEnviromentOperaciones',
  ApiUrlSuffixRepartos = 'PrefixEnviromentRepartos',
  ApiUrlSuffixSujetos = 'PrefixEnviromentSujetos',
  ApiUrlSuffixViajes = 'PrefixEnviromentViajes',
  ApiUrlSuffixStorageManagement = 'PrefixEnviromentStorageManagement',
  ApiUrlSuffixConceptosFactura = 'PrefixEnviromentConceptoFactura',
  BalanceStorage = 'Balance:Storage',
  SiteHelpNewReleaseNotification = 'ReactSiteHelp:NewReleaseNotification',
  PrefixEnviromentPrognoss = 'PrefixEnviromentPrognoss',
  PrefixEnviromentArgentia = 'PrefixEnviromentArgentia',
  ApiUrlSuffixConceptQlik = 'PrefixEnviromentConceptQlik',
  ApiUrlSuffixConceptApi = 'PrefixEnviromentConceptApi',
  WebHostQlik = 'WEB_HOST_QLIK',
  ReactGA = 'ReactSite:Analytics:gaID',
  ApiUrlSuffixHub = 'PrefixEnviromentHub',
  EmbeddedReport = 'EmbeddedReport:PrevisionLP:Report1',
  EmbeddedReportLP = 'EmbeddedReport:PrevisionLP:Report2',
  EmbeddedReportLeadsGas = 'EmbeddedReport:Leads:InformeGas',
  EmbeddedReportLeadsElectricity = 'EmbeddedReport:Leads:InformeElectricidad',
  StorageRegulatoryReporting = 'RegulatoryReporting:Storage',
  ContainerRegulatoryReporting = 'RegulatoryReporting:Container',
  ApiUrlSuffixConceptos = 'PrefixEnviromentConceptos',
  FrontNoticeDueDate = 'FrontNoticeDueDate',
  PrefixEnviromentFrontServices = 'PrefixEnviromentFrontServices'
}
